"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isClipSiteUrlCreateWithParticipantId = void 0;
const isClipSiteUrlCreateWithParticipantId = (institutionId) => {
    const embeddedInstitutionIds = process.env.CLIP_SITE_URLS_INCLUDE_INSTITUTION_IDS;
    if (embeddedInstitutionIds) {
        const institutionList = embeddedInstitutionIds.split(",");
        const participantIdIncludeInClipSites = institutionList.filter(item => item === institutionId);
        if (participantIdIncludeInClipSites.length > 0) {
            return true;
        }
    }
    return false;
};
exports.isClipSiteUrlCreateWithParticipantId = isClipSiteUrlCreateWithParticipantId;
//# sourceMappingURL=embed-institution.js.map